import UserActivityLogs from "@/views/global/management/user_activity_logs/UserActivityLogs.vue";
import EnquiryChat from "@/views/probaworkflows_base/entity/enquiry_chat/EnquiryChat.vue";
import ApplicationOverviewDetails from "@/views/probaworkflows_base/entity/entity_applications/application_overview_details/ApplicationOverviewDetails.vue";
import EntityApplicationOverview from "@/views/probaworkflows_base/entity/entity_applications/entity_application_overview/EntityApplicationOverview.vue";
import RequestedInformationUpdate from "@/views/probaworkflows_base/entity/requested_information/requested_infomation_update/RequestedInformationUpdate.vue";
import ResolvedRequests from "@/views/probaworkflows_base/entity/requested_information/resolved_requests/ResolvedRequests.vue";
import UnresolvedRequest from "@/views/probaworkflows_base/entity/requested_information/unresolved_request/UnresolvedRequest.vue";
import ViewTrustForm from "@/views/probaworkflows_base/entity/view_trust_form/ViewTrustForm.vue";
import EntityRiskAssessment from "@/views/probaworkflows_base/entity/entity_risk_assessment/EntityRiskAssessment.vue";
import TrustCompliance from "@/views/probaworkflows_base/management/compliance_management/trust_compliance/TrustCompliance.vue";
import ViewComplianceRequirements from "@/views/probaworkflows_base/management/compliance_management/view_compliance_requirements/ViewComplianceRequirements.vue";
import AssignQuestionsToEnquiryForm from "@/views/probaworkflows_base/management/customer_management/assign_questions_to_enquiry_form/AssignQuestionsToEnquiryForm.vue";
import CreateEnquiryForm from "@/views/probaworkflows_base/management/customer_management/create_enquiry_form/CreateEnquiryForm.vue";
import CreateEnquiryStages from "@/views/probaworkflows_base/management/customer_management/create_enquiry_stages/CreateEnquiryStages.vue";
import CreateTransitionRules from "@/views/probaworkflows_base/management/customer_management/create_transition_rules/CreateTransitionRules.vue";
import ManageAssignedWorkflows from "@/views/probaworkflows_base/management/entity_management/approval_rules_management/manage_assigned_workflows/ManageAssignedWorkflows.vue";
import ManageWorkflows from "@/views/probaworkflows_base/management/entity_management/approval_rules_management/manage_workflows/ManageWorkflows.vue";
import LeadsResponses from '@/views/probaworkflows_base/management/leads_management/leads_responses/LeadsResponses.vue';
import LeadsManagement from "@/views/probaworkflows_base/management/leads_management/manage_leads/LeadsManagement.vue";
import PaymentApproval from '@/views/probaworkflows_base/management/leads_management/payment_approval/PaymentApproval.vue';
import ManageQuestions from "@/views/probaworkflows_base/management/manage_questions/ManageQuestions.vue";
import ManageRisks from "@/views/probaworkflows_base/management/risk_management/ManageRisks.vue";
import RiskQuestions from "@/views/probaworkflows_base/management/risk_management/risk_questions/RiskQuestions.vue";
import StatusManagement from "@/views/probaworkflows_base/management/status_management/StatusManagement.vue";
import UploadMeetingMinutes from "@/views/probaworkflows_base/management/customer_management/upload_meeting_minutes/UploadMeetingMinutes.vue";
import ApplicationLog from "@/views/probaworkflows_base/management/trust_applications/application_log/ApplicationLog.vue";
import PendingApplications from "@/views/probaworkflows_base/management/trust_applications/pending_applications/PendingApplications.vue";
import ResolveRequests from "@/views/probaworkflows_base/management/trust_applications/view_requested_information/resolve_requests/ResolveRequests.vue";
import ViewRequests from "@/views/probaworkflows_base/management/trust_applications/view_requested_information/view_requests/ViewRequests.vue";
import ViewResolvedRequests from "@/views/probaworkflows_base/management/trust_applications/view_requested_information/view_resolved_requests/ViewResolvedRequests.vue";
import ManualVerification from "@/views/probaworkflows_base/verification/manual_verification/ManualVerification.vue";
import InvoiceOverview from "@/views/probaworkflows_base/invoicing/invoice_overview/InvoiceOverview.vue";
import InvoiceSteps from "@/views/probaworkflows_base/invoicing/invoice_steps/InvoiceSteps.vue";
import TrustInvoicing from "@/views/probaworkflows_base/invoicing/trust_invoicing/TrustInvoicing.vue";
import EntityInvoiceOverview from "@/views/probaworkflows_base/entity/entity_applications/entity_invoice_overview/EntityInvoiceOverview.vue";
import VerificationOverview from "@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue";
import VerificationResults from "@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_results/VerificationResults.vue";
import ComplianceRules from "@/views/probaworkflows_base/management/compliance_management/compliance_rules/ComplianceRules.vue";
import AssignComplianceRules from "@/views/probaworkflows_base/management/compliance_management/assign_compliance_rules/AssignComplianceRules.vue";
import ComplianceOverview from "@/views/probaworkflows_base/management/compliance_management/compliance_overview/ComplianceOverview.vue";
import ViewContracts from "@/views/probaworkflows_base/entity/view_contracts/ViewContracts.vue";
import SignedContract from "@/views/probaworkflows_base/management/trust_applications/signed_contract/SignedContract.vue";
import SigningWorkflow from "@/views/probaworkflows_base/management/signing_workflow_management/signing_workflow/SigningWorkflow.vue";
import TrustDirectory from "@/views/probaworkflows_base/management/manage_approved_applicants/trust_directory/TrustDirectory.vue";
import ViewApprovedApplicant from "@/views/probaworkflows_base/management/manage_approved_applicants/view_approved_applicant/ViewApprovedApplicant.vue";
import OverviewOfProfile from "@/views/probaworkflows_base/management/trust_applications/overview_of_profile/OverviewOfProfile.vue";
import LeadQuestionnaire from "@/views/probaworkflows_base/entity/lead_questionnaire/LeadQuestionnaire.vue"
import LeadQuestionnaireForm from "@/views/probaworkflows_base/entity/lead_questionnaire_form/LeadQuestionnaireForm.vue"
import AnswerRiskAssessment from "@/views/probaworkflows_base/entity/answer_risk_assessment/AnswerRiskAssessment.vue";
import ComplianceNotifications from "@/views/probaworkflows_base/management/compliance_management/compliance_notifications/ComplianceNotifications.vue";
import Services from "@/views/probaworkflows_base/invoicing/services/ProjectServices.vue";
import MasterSubmissions from "@/views/probaworkflows_base/management/trust_applications/master_submissions/MasterSubmissions.vue";
import MasterOfficeSubmissions from "@/views/probaworkflows_base/management/master_office_submissions/MasterOfficeSubmissions.vue"
import EntityEnquiryManagement from "@/views/probaworkflows_base/entity/entity_enquiry_management/EntityEnquiryManagement.vue";
import ProofOfPayments from "@/views/probaworkflows_base/entity/proof_of_payments/ProofOfPayments.vue";
import PackageServices from "@/views/probaworkflows_base/invoicing/package_services/PackageServices.vue";
import EntityReviewQuote from "@/views/probaworkflows_base/entity/entity_applications/entity_review_quote/EntityReviewQuote.vue";
import VerificationServicesConfigurations from "@/views/probaworkflows_base/verification/verification_services_configurations/VerificationServicesConfigurations.vue";
import ApplicationAssignment from '@/views/probaworkflows_base/management/trust_applications/application_assignment/ApplicationAssignment.vue';
import ViewJobProfile from '@/views/probaworkflows_base/recruitment/view_job_profile/ViewJobProfile.vue';
import ViewApplicants from '@/views/probaworkflows_base/management/trust_applications/view_applicants/ViewApplicants.vue';
import ApplyForJobs from '@/views/probaworkflows_base/entity/apply_for_jobs/ApplyForJobs.vue';

export default [
    //signing workflow
       {
        path: "signing_workflow",
        name: "signing_workflow",
        component: SigningWorkflow,
        meta: { 
          breadcrumb: "Documents Workflow",
          branch: 'configure', 
          isTab: true
        }
    },

      // trust compliance
      {
        path: "/trust_compliance",
        name: "trust_compliance",
        component: TrustCompliance,
      },
      {
        path: "/view_compliance_requirements",
        name: "view_compliance_requirements",
        component: ViewComplianceRequirements,
      },
      {
        path: "/compliance_notifications",
        name: "compliance_notifications",
        component: ComplianceNotifications,
      },
      {
        path: "/compliance_overview",
        name: "compliance_overview",
        component: ComplianceOverview,
      },
      {
        path: "/compliance_rules",
        name: "compliance_rules",
        component: ComplianceRules,
      },
      {
        path: "/assign_compliance_rules",
        name: "assign_compliance_rules",
        component: AssignComplianceRules,
      },

      {
        path: "/manual_verification",
        name: "manual_verification",
        component: ManualVerification,
      },
      {
        path: "/pending_applications",
        name: "pending_applications",
        component: PendingApplications,
        meta: { 
          breadcrumb: "Application Management",
          branch: 'overview',
          isTab: true
        }
      },
      {
        path: "/overview_of_profile",
        name: "overview_of_profile",
        component: OverviewOfProfile,
        meta: { 
          breadcrumb: "Overview Of Profile",
          branch: 'overview',
          isDynamic: true
        }
      },

      {
        path: "/master_submissions",
        name: "master_submissions",
        component: MasterSubmissions,
      },

      {
        path: "/master_office_submissions",
        name: "master_office_submissions",
        component: MasterOfficeSubmissions,
      },

      {
        path: "/signed_contract",
        name: "signed_contract",
        component: SignedContract,
      },


      {
        path: "/view_requests",
        name: "view_requests",
        component: ViewRequests,
      },

      {
        path: "/resolve_requests",
        name: "resolve_requests",
        component: ResolveRequests,
      },

       {
        path: "/view_resolved_requests",
        name: "view_resolved_requests",
        component: ViewResolvedRequests,
      },

      {
        path: "/application_log",
        name: "application_log",
        component: ApplicationLog,
      },
      {
        path: "/user_activity_logs",
        name: "user_activity_logs",
        component: UserActivityLogs,
      },
      {
        path: "/manage_questions",
        name: "ManageQuestions",
        component: ManageQuestions,
        meta: { 
          breadcrumb: "Question Management",
          branch: 'configure', 
          isTab: true
        }
      },
      {
        path: "/invoicing",
        name: "invoicing",
        component: TrustInvoicing,
      },
      {
        path: "/status_management",
        name: "status_management",
        component: StatusManagement,
        meta: { 
          breadcrumb: "Status Management",
          branch: 'configure', 
          isTab: true
        }
      },
      {
        path: "/manage_workflows",
        name: "manage_workflows",
        component: ManageWorkflows,
      },
      {
        path: "/invoice_steps",
        name: "invoice_steps",
        component: InvoiceSteps,
      },
      {
        path: "/entity_review_quote",
        name: "entity_review_quote",
        component: EntityReviewQuote,
      },

      {
        path: "/invoice_overview",
        name: "invoice_overview",
        component: InvoiceOverview,
      },
      {
        path: "/verification_overview",
        name: "verification_overview",
        component: VerificationOverview,
      },

       {
        path: "/verification_results",
        name: "verification_results",
        component: VerificationResults,
      },
      {
        path: "/application_assignment",
        name: "application_assignment",
        component: ApplicationAssignment,
      },

      // enquiry
      {
        path: "/create_enquiry_stages",
        name: "create_enquiry_stages",
        component: CreateEnquiryStages,
        meta: { 
          breadcrumb: "Enquiry Status Management",
          branch: 'configure',
          isTab: true 
        }
      },
      {
        path: "/create_transition_rules",
        name: "create_transition_rules",
        component: CreateTransitionRules,
      },
      {
        path: "/create_enquiry_form",
        name: "create_enquiry_form",
        component: CreateEnquiryForm,
        meta: { 
          breadcrumb: "Enquiry Management",
          branch: 'configure', 
          isTab: true
        }
      },
      {
        path: "/assign_questions_to_enquiry_form",
        name: "assign_questions_to_enquiry_form",
        component: AssignQuestionsToEnquiryForm,
        meta: { 
          breadcrumb: "Enquiry Form Question Management",
          branch: 'configure', 
          isDynamic: true
        }
      },

      {
        path: "/leads_management",
        name: "leads_management",
        component: LeadsManagement,
        meta: { 
          breadcrumb: "Leads Management",
          branch: 'overview', 
          isTab: true
         }
      },
      {
        path: '/leads_responses',
        name: 'leads_responses',
        component:  LeadsResponses,
        meta: { 
          breadcrumb: "Leads Responses",
          branch: 'overview',
          isDynamic: true
        }
      },
      {
        path: '/payment_approval',
        name: 'payment_approval',
        component:  PaymentApproval
      },

      {
        path: "/manage_assigned_workflows",
        name: "manage_assigned_workflows",
        component: ManageAssignedWorkflows,
        meta: { 
          breadcrumb: "Status Assignment Management", 
          branch: 'configure', 
          isDynamic: true
        }
      },
      {
        path: "/upload_meeting_minutes",
        name: "upload_meeting_minutes",
        component: UploadMeetingMinutes,
      },
      {
        path: "/entity_enquiry_management",
        name: "entity_enquiry_management",
        component: EntityEnquiryManagement,
      },

         {
        path: "/proof_of_payments",
        name: "proof_of_payments",
        component: ProofOfPayments,
      },

      // pages on founder side
      {
        path: "/view_all_user_forms",
        name: "view_all_user_forms",
        component: ViewTrustForm,
      },
      {
        path: "/apply_for_jobs",
        name: "apply_for_jobs",
        component: ApplyForJobs,
        meta: { requires_auth: false, requires_otp: false },
      },
      {
        path: "/requested_information_update",
        name: "requested_information_update",
        component: RequestedInformationUpdate,
      },
      {
        path: "/unresolved_request",
        name: "unresolved_request",
        component: UnresolvedRequest,
      },
      {
        path: "/resolved_requests",
        name: "resolved_requests",
        component: ResolvedRequests,
      },
      {
        path: "/enquiry_chat",
        name: "enquiry_chat",
        component: EnquiryChat,
      },
      {
        path: "/lead_questionnaire",
        name: "lead_questionnaire",
        component: LeadQuestionnaire,
      },
      {
        path: "/lead_questionnaire_form",
        name: "lead_questionnaire_form",
        component: LeadQuestionnaireForm,
      },

      {
        path: "/view_contracts",
        name: "view_contracts",
        component: ViewContracts,
      },
      {
        path: "/entity_risk_assessment",
        name: "entity_risk_assessment",
        component: EntityRiskAssessment,
      },

      {
        path: "/entity_application_overview",
        name: "entity_application_overview",
        component: EntityApplicationOverview,
      },

      {
        path: "/application_overview_details",
        name: "application_overview_details",
        component: ApplicationOverviewDetails,
      },
      {
        path: "/manage_risks",
        name: "manage_risks",
        component: ManageRisks,
        meta: { 
          breadcrumb: "Risks Management",
          branch: 'configure', 
          isTab: true
        }
      },
      {
        path: "/risk_questions",
        name: "risk_questions",
        component: RiskQuestions,
        meta: { 
          breadcrumb: "Risk Questions", 
          branch: 'configure', 
          isDynamic: true
        }
      },
      {
        path: "/answer_risk_assessment",
        name: "answer_risk_assessment",
        component: AnswerRiskAssessment,
      },

      {
        path: "/entity_invoice_overview",
        name: "entity_invoice_overview",
        component: EntityInvoiceOverview,
      },
      {
        path: "/entity_overview",
        name: "entity_overview",
        component: ViewTrustForm
      },

      {
        path: "/trust_directory",
        name: "trust_directory",
        component: TrustDirectory,
      },

      {
        path: "/view_approved_applicant",
        name: "view_approved_applicant",
        component: ViewApprovedApplicant,
      },

      {
        path: "/services",
        name: "services",
        component: Services,
        meta: { 
          breadcrumb: "Services Management",
          branch: 'configure', 
          isTab: true 
      }
      },

      {
        path: "/package_services",
        name: "package_services",
        component: PackageServices,
        meta: { 
          breadcrumb: "Package Management",
          branch: 'configure', 
          isTab: true 
        }
      },

      {
        path: "/verification_services_configurations",
        name: "verification_services_configurations",
        component: VerificationServicesConfigurations,
        meta: { 
          breadcrumb: "Verification Services",
          branch: 'configure', 
          isTab: true
         }
      },
      {
        path: '/view_applicants',
        name: 'view_applicants',
        component: ViewApplicants,
        props: true,
        meta: { 
          breadcrumb: "View Applicants",
          branch: 'overview',
          isDynamic: true
        }
      },
      {
        path: '/view_job_profile/:id',
        name: 'view_job_profile',
        component: ViewJobProfile,
        props: true
      }
      
]